import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { WysiwygAction } from '../../../adapter/wysiwyg-adapter.types';
import { Placeholder } from '../../placeholder';
import { ActionType, WysiwygPlaceholderAction } from '../wysiwyg-placeholder.types';

@Component({
  selector: 'rt-wysiwyg-placeholder-dropdown',
  styleUrls: ['./wysiwyg-placeholder-dropdown.component.less'],
  templateUrl: './wysiwyg-placeholder-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WysiwygPlaceholderDropdownComponent {
  @Input() public active: Placeholder;
  @Input() public placeholders: Placeholder[];

  @Output() public action: EventEmitter<WysiwygPlaceholderAction> = new EventEmitter();

  public emitPlaceholderChange(placeholder: Placeholder): void {
    this.action.emit(new WysiwygAction(ActionType.PlaceholderChange, placeholder));
  }

  public emitPlaceholderDelete(placeholder: Placeholder): void {
    this.action.emit(new WysiwygAction(ActionType.PlaceholderDelete, placeholder));
  }

  public trackByPlaceholderId(placeholder: Placeholder, index: number): string {
    return `${placeholder.id}#${index}`;
  }

  public withoutBrackets(str: string): string {
    return str.slice(1, -1);
  }
}
